<template>
	<div class="dialog">
		<el-dialog title="选择成员" :visible.sync="visible" width="1000px" :before-close="handleClose2">

			<span>
				<div class="table">
					<div class="table_top">
						<div class="top_left">
							<p>组织架构</p>
						</div>
						<div class="top_right">
							<p>已选择</p>
						</div>
					</div>
					<div class="table_content">
						<div class="conter_left">
							<el-input placeholder="请输入成员姓名" class="input_w260" v-model="filterText">
							</el-input>
							<el-tree class="tree_w250" :data="data" node-key="name" :default-checked-keys="checked"
								ref="tree" :filter-node-method="filterNode" @check="getCheckedNodes"
								:props="defaultProps" show-checkbox>
							</el-tree>
						</div>
						<div class="conter_right">
							<div class="department">
								<div class="right_title">
									<span>部门</span>
									<span class="not_data" v-show="not_data_show1">暂无数据</span>
								</div>
								<div class="right_conter">
									<el-tag v-for="tag in select.label"  :disable-transitions="false"
										@close="handleClose(tag)" type="info">
										{{tag}}
									</el-tag>
								</div>
							</div>
							<div class="member">
								<div class="right_title">
									<span>成员</span>
									<span class="not_data" v-show="not_data_show2">暂无数据</span>
								</div>
								<div class="right_conter">
									<el-tag v-for="tag in select.children.label"  @close="handleClose1(tag)"
										type="info">
										{{tag}}
									</el-tag>
								</div>
							</div>

						</div>
					</div>
				</div>
			</span>

			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="select_members_close">确 认</el-button>
				<el-button @click="resetChecked">清 空</el-button>
			</span>
		</el-dialog>

	</div>
</template>

<script>
	import {
		getAllPosterClassList
	} from 'network/hk_member'

	export default {
		name: "SelectMembersDialog",
		props: {
			show: {
				type: Boolean,
				default: false,
			},
			select_value: {
				type: Array,
				default: ()=>{
					return []
				}
			},
			checked: {
				type: Array,
				default:  ()=>{
					return []
				}
			},
			
		},
		data() {
			return {
				filterText: '',
				data: [],
				tags: ['标签1', '标签2', '标签3'],

				select: {
					id: [],
					label: [],
					children: {
						id: [],
						label: [],
						user_id: []
					}
				},
				defaultProps: {
					children: 'son',
					label: 'name'
				},
				// 默认选中
			}
		},
		watch: {
			filterText(val) {
				this.$refs.tree.filter(val);
			}
		},
		computed: {
			visible: {
				get() {
					return this.show
				},
				set(val) {
					this.$emit('update:show', val) // visible 改变的时候通知父组件
				}
			},

			not_data_show1() {
				return this.select.label.length === 0;
			},
			not_data_show2() {
				return this.select.children.label.length === 0;
			}
		},
		created() {
			this.getAllPosterClassList()
			this.select.children.label = this.checked
		},

		methods: {
			// 弹出  点击遮罩和 x 关闭弹出
			handleClose2(done) {
				// this.$emit('handclose')
				this.$emit('update:show', false)
			},
			filterNode(value, data) {
				if (!value) return true;
				return data.name.indexOf(value) !== -1;
			},

			handleClose(tag) {
				let tag_index1 = this.select.label.indexOf(tag)
				this.select.label.splice(tag_index1, 1);
				this.select.id.splice(tag_index1, 1);

				this.$refs.tree.setCheckedKeys(this.select.id)
			},
			handleClose1(tag) {
				let tag_index2 = this.select.children.label.indexOf(tag)
				this.select.children.label.splice(tag_index2, 1);
				this.select.children.id.splice(tag_index2, 1);
				this.select.children.user_id.splice(tag_index2, 1);

				this.$refs.tree.setCheckedKeys(this.select.children.id)
			},

			select_members_open() {
				this.show = true;
			},
			select_members_close() {
				this.$emit('update:show', false)
				this.$emit('update:select_value', this.select.children.id)
				this.$emit('update:select_name', this.select.children.label)
				this.$emit('update:select_userid', this.select.children.user_id)
				console.log(this.select.children,'this.select.children')
			},
			open() {
				this.show = true;
			},
			close() {
				this.show = false
			},

			resetChecked() {
				this.$refs.tree.setCheckedKeys([]);
				this.$refs.tree.setCheckedNodes([]);
				this.select.label = []
				this.select.children.label = []
				this.select.children.id = []
				this.select.children.user_id = []
			},
			getCheckedNodes() {
				this.select.id = []
				this.select.label = []
				this.select.children.id = []
				this.select.children.label = []
				this.select.children.user_id = []
				let list = this.$refs.tree.getCheckedNodes()
				for (let p in list) {
					if (list[p].level !== undefined) {
						this.select.label.push(list[p].name)
						this.select.id.push(list[p].department_id)
					} else if (list[p].level === undefined) {
						this.select.children.label.push(list[p].name)
						this.select.children.id.push(list[p].member_id)
						this.select.children.user_id.push(list[p].userid)
					}
				}
			},

			getAllPosterClassList() {
				getAllPosterClassList().then(res => {
					if (res.code === 10000) {
						this.data = []
						this.data.push(res.result)
					}
				})
			},


		}
	}
</script>

<style scoped>
	.table {
		width: 100%;
		height: 385px;
		border: 1px solid rgb(239, 239, 239);
	}

	.table_top {
		height: 50px;
		background: rgb(250, 250, 250);
		display: flex;
		border-bottom: 1px solid rgb(239, 239, 239);
	}

	.top_left {
		width: 300px;
		height: 50px;
		border-right: 1px solid rgb(239, 239, 239);
	}

	.top_right {
		width: 639px;
		height: 50px;
	}

	.table_top p {
		text-align: center;
		font-size: 16px;
		color: rgba(0, 0, 0, 1);
		line-height: 50px;
	}

	.table_content {
		display: flex;
	}

	.conter_left {
		min-width: 260px;
		height: 295px;
		padding: 20px;
		border-right: 1px solid rgb(239, 239, 239);
	}

	.conter_right {
		width: 599px;
		height: 295px;
		padding: 20px;
	}

	.department {
		width: 100%;
		height: auto;
		padding-bottom: 10px;
	}

	.right_title {
		height: 38px;
		line-height: 38px;
	}

	.right_title .not_data {
		margin-left: 20px;
		color: rgba(178, 178, 178, 1);
	}

	.right_conter {
		width: 100%;
		height: auto;
	}

	.input_w260 {
		width: 260px;
		margin: 0 auto;
	}

	.tree_w250 {
		width: 250px;
		margin: 15px auto;
		height: 250px;
		overflow-y: scroll
	}

	.el-tag.el-tag--info {
		margin-right: 10px;
		margin-bottom: 10px;
	}
</style>
